/**
 * The rules behind the Subscriptions page's "Mark refunded" action, kept out of the component so
 * they can be tested without rendering a table.
 */

/** Null on a row older than the field means ACTIVE, as the backend resolves it. */
export const subscriptionStatus = (status?: string | null): string =>
  (status || 'ACTIVE').toUpperCase();

/**
 * A refund can be recorded against a live or a cancelled purchase; never twice, and never against
 * something that cost nothing. A free city-expansion post is a ₹0 row: offering "Mark refunded" on
 * it led only to the backend's "more than zero" refusal.
 */
export const canMarkRefunded = (status?: string | null, amount?: string | null): boolean =>
  ['ACTIVE', 'CANCELLED'].includes(subscriptionStatus(status))
  && !(amount != null && amount !== '' && Number(amount) === 0);

/**
 * Why the amount cannot be sent, or null when it can. Mirrors the backend's rule (> 0 and no more
 * than was paid) so the admin is told here rather than by a refusal after they press the button.
 */
export const refundAmountError = (amount: string, paid?: string | null): string | null => {
  const trimmed = amount.trim();
  if (!trimmed) return 'Enter the amount refunded.';
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return 'Enter a number, e.g. 399 or 399.50.';
  const value = Number(trimmed);
  if (!(value > 0)) return 'The amount must be more than zero.';
  const max = Number(paid);
  if (paid && Number.isFinite(max) && value > max) return `No more than the ${paid} paid.`;
  return null;
};
